import type {Router, RouteRecordRaw} from 'vue-router';
import {createRouter, createWebHistory} from 'vue-router';

import settings from '@/config/settings';

import {ERoleSystem} from '@/api/enums/role';

import {EAntIconUrl} from '@/assets/ant/icon/enums';

import user from '@/services/presenters/user/current';

import {ESettingsFrontType} from '@/config/enums';

import {adminRoutes} from '@/app/admin/router';
import {clientPageRoutes} from '@/app/client/router/pages';
import {commonPageRoutes} from '@/router/pages';

const {hasAccessByRole} = user;
const {hasAccessByMode} = settings.SERVICES.FRONT.PRESENTER;

const routes: Array<RouteRecordRaw> = [
  {
    path: '/map',
    name: 'MapPage',
    meta: {
      menu: {
        name: 'Карта',
        icon: EAntIconUrl.COMPASS_OUTLINED,
      },
      access_mode: [ESettingsFrontType.CLIENT, ESettingsFrontType.ADMIN],
      access_roles: [
        ERoleSystem.USER,
        ERoleSystem.ADMIN,
        ERoleSystem.ADMIN_VIEW,
      ],
    },
    component: () => import('@/app/client/pages/MapPage.vue'),
  },
  {
    path: '/stream/:id',
    name: 'stream',
    meta: {
      access_mode: [ESettingsFrontType.CLIENT, ESettingsFrontType.ADMIN],
      access_roles: [
        ERoleSystem.USER,
        ERoleSystem.ADMIN,
        ERoleSystem.ADMIN_VIEW,
      ],
    },
    component: () => import('@/app/client/pages/StreamPage.vue'),
  },
  {
    path: '/',
    name: 'BasePage',
    redirect: '/map',
    component: () => import('@/app/base/pages/BasePage.vue'),
    children: [...commonPageRoutes, ...clientPageRoutes, ...adminRoutes],
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: '/not_found',
  },
];

export let router: Router | undefined = undefined;

export const getRouter = () => router as Router;
export const initRouter = () => {
  router = createRouter({
    history: createWebHistory(import.meta.env.BASE_URL),
    routes,
  });

  router.beforeEach(async (to, from, next) => {
    const accessRoles: ERoleSystem[] =
      (to.meta?.access_roles as ERoleSystem[]) ?? [];
    const accessMode: ESettingsFrontType[] =
      (to.meta?.access_mode as ESettingsFrontType[]) ?? [];

    if (!hasAccessByMode(accessMode)) next('/not_found');
    else if (!hasAccessByRole(accessRoles)) next('/forbidden');
    else next();
  });

  return router;
};
